<template>
  <section>
    <div v-if="isPC" class="product-list">
      <!-- 品类+筛选 -->
      <div v-show="!isSearches" class="navigation">
        <span class="pointer" @click="$router.push('/mall')">{{ $t('Index.ProductList.AllProducts') }}</span>
        <!-- <i class="iconfont icon-a-arrow-left-s-line2"></i> -->
        <!-- <span style="color:#8B93A3;" >{{ $t('Index.ProductList.AllProducts') }}</span> -->
        <!-- <el-button type="text" @click="jumpCategory(-1)">All</el-button> -->
        <span v-for="(item, i) in selectCategoryList" :key="item.id"><i class="iconfont icon-a-arrow-left-s-line2"></i>
          <el-button type="text" @click="jumpCategory(item, i)">
            <span v-if="i === selectCategoryList.length - 1">
              <h1 style="font-size: 14px">{{ item.name }}</h1>
            </span>
            <template v-else>
              {{ item.name }}
            </template>
          </el-button>
        </span>
      </div>
      <div v-show="!isSearches" class="filter">
        <vue-scroll :style="{ height: isShowAdvertis ? 'calc(100vh - 220px)' : 'calc(100vh - 170px)', width: '100%' }">
          <div style="padding: 0 20px;padding-bottom:20px">
            <h3 class="filter-title">{{ $t('Index.ProductList.Category') }}</h3>
            <category-select ref="customCategory" @change="categoryChange" @selectCategory="selectCategory" />
            <h3 class="filter-title f-b-c">
              {{ $t('Index.ProductList.Prices') }}
              <span style="font-size: 14px; font-weight: 400;">${{listParams.minPrice}} - ${{listParams.maxPrice}}</span>
            </h3>
            <el-slider v-model="price" range :max="200" @change="priceChange" style="margin: 0 10px;" />
            <!-- 商品属性 -->
            <el-collapse v-model="attributeOpenList">
              <el-collapse-item :title="$t('inSrock.shippingFrom')" name="shipFrom">
                <el-radio-group v-model="listParams.countryCodeArray" @change="resetPage" class="shipFromRadio">
                  <el-radio :label="item.countryCode" v-for="item in shippingFromList" :key="item.countryCode">{{item.countryCn}}</el-radio>
                </el-radio-group>
              </el-collapse-item>
              <el-collapse-item :title="$t('inSrock.supplierRank')" name="supplierRank">
                <el-checkbox-group v-model="listParams.supplierLevels" @change="resetPage">
                  <el-tooltip effect="dark" :offset="-20" :content="$t('inSrock.supplierRankA')" placement="bottom-start">
                    <el-checkbox :label="1">A</el-checkbox>
                  </el-tooltip>
                  <!-- <el-tooltip effect="dark" :offset="-20" :content="$t('inSrock.supplierRankB')" placement="bottom-start">
                    <el-checkbox :label="2">B</el-checkbox>
                  </el-tooltip>
                  <el-tooltip effect="dark" :offset="-20" :content="$t('inSrock.supplierRankC')" placement="bottom-start">
                    <el-checkbox :label="3">C</el-checkbox>
                  </el-tooltip> -->
                </el-checkbox-group>
              </el-collapse-item>
              <el-collapse-item v-for="item in productAttributeList" :key="item.code" :title="item.name" :name="item.code">
                <el-checkbox v-for="attr in item.value" :key="attr.code" v-model="attr.checked" style="display: block; max-width: 180px; overflow: hidden;" @change="attributeChange(attr)">{{attr.name | largeHump}}</el-checkbox>
              </el-collapse-item>
            </el-collapse>
          </div>
        </vue-scroll>
      </div>

      <!-- 商品列表 -->
      <div class="product-box" :style="{ padding: isSearches ? '15px 0 0 0' : '40px 0 0 280px', paddingTop: isSearches ? '10px' : '' }">
        <div v-if="!isSearches" class="product-box-header f-b-c">
          <custom-filter :filter-list="filterList" @close="closeTag" @closeAll="closeAllTag" />
          <div class="f">
            <!-- <div style="line-height:36px;margin-right:8px">{{ $t('inSrock.shippingFrom') }}:</div>
            <el-select v-model="listParams.countryCodeArray" collapse-tags :placeholder="$t('inSrock.shippingFrom')" style="margin-right: 15px;width:140px" @change="resetPage">
              <el-option v-for="item in shippingFromList" :key="item.countryCode" :label="item.countryCn" :value="item.countryCode"></el-option>
            </el-select> -->
            <product-sort  @change="sortChange" />
          </div>
        </div>

        <div class="product-box-list f-b fw-w" v-loading="listLoading">
          <product-item v-for="item in productList" :key="item.kkProductId" :product="item" :productInfoVisible="true" :style="{ width: isSearches ? '19%' : '24%' }" style="padding-bottom: 20px;" :currentWarehouse="listParams.countryCodeArray" kklocation="productList" reportType="product" />
          <div class="empty-product"></div>
          <div class="empty-product"></div>
          <div class="empty-product"></div>
          <div class="empty-product"></div>
        </div>
        <div v-show="productList.length === 0 && !listLoading" class="empty">
          <div class=" f-c-c fd-c">
            <img src="@/assets/img/product_empty.svg" alt="">
          <p>{{ $t('Index.ProductList.NoProductFound') }}</p>
          </div>
          <div class="recommend-product" v-if="likeProductList.length>0">
            <h2>{{ $t('Index.ProductList.Tips1') }}</h2>
            <div class="f-b fw-w productList" style="margin-top:20px;padding-bottom:20px">
              <custom-product v-for="item in likeProductList" :key="item.kkProductId" :product="item" style="width: 19%;" />
            </div>
          </div>
        </div>
        <el-pagination style="float: right; padding-bottom: 10px;" background layout="prev, pager, next" :current-page="listParams.pageNumber" :page-size="listParams.pageSize" :total="total" hide-on-single-page @current-change="pageChange" />
        <el-divider class="custom-divider"></el-divider>
        <div v-if="categoryPageDescription" class="description">
          <h2 class="toggle-title">{{ categoryPageTitle }}</h2>
          <i v-if="isExpanded" class="iconfont icon-07jiantouxiangshang toggle-button" @click="toggleDescription" />
          <i v-else class="iconfont icon-07jiantouxiangxia toggle-button" @click="toggleDescription" />
          <div :class="{'collapsed': !isExpanded}" class="description-text ellipsis2" :style="{ overflow: !isExpanded ? 'hidden' : 'auto', height: !isExpanded ? '35px' : 'unset', '-webkit-line-clamp':!isExpanded ? '2' : 'unset' }">
            {{ categoryPageDescription }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="mobileContain" v-loading="listLoading">
      <div class="topForm" id="topForm" v-if="!isSearches">
        <van-dropdown-menu>
          <van-dropdown-item v-model="mobileShipFrom" :title="$t('Index.ProductList.ShipFrom')" ref="shipFromSelectMobile">
            <van-cell center :title="item.countryCn" v-for="item in shippingFromList" :class="[item.checked?'checked-country':'']" :key="item.countryCn" @click="shipFromChangeMobile(item)">
              <template #right-icon>
                <i class="el-icon-check" v-if="item.checked"></i>
              </template>
            </van-cell>
          </van-dropdown-item>
          <van-dropdown-item :options="sortListForMobile" @change="value => sortChangeMobile(value)" v-model="sortKeyForMobile" :title="$t('Index.ProductList.SortWay')"></van-dropdown-item>
        </van-dropdown-menu>
        <div class="Fabric" @click="fabricShow = true">
          {{ $t('Index.ProductList.Fabric') }}
          <van-icon name="filter-o" />
        </div>
      </div>
      <div class="topForm top-search" v-if="isSearches">
        <SearchBar @search="searchHandle"></SearchBar>
      </div>
      <div class="productList f fw-w bg-white">
        <div :style="{ width: '50%', padding: '.1rem' }" v-for="item in productList" :key="item.kkProductId" v-loading="listLoading">
          <product-item :product="item" :productInfoVisible="true" class="product_item" kklocation="productList" reportType="product" />
          <!-- <div class="f warehouse_box" style="margin-bottom:.3rem;font-size:.2rem">
              <div v-for="name in item.warehouse" :key="name" class="warehouse_tag active">{{name}}</div>
            </div> -->
        </div>
        <!-- <product-item v-for="item in productList" :key="item.kkProductId" :product="item" :productInfoVisible="true" :style="{ width: '50%',padding: '.1rem' }" /> -->
        <div v-if="!productList.length && !listLoading" class="empty">
          <div class="f-c-c fd-c">
            <img src="@/assets/img/activity_empty.svg" alt="">
            <p>{{ $t('Index.Album.Components.TemplateTwo.NoProductFound') }}</p>
          </div>
        </div>
      </div>
      <van-popup v-model="fabricShow" position="right" :style="{ width: '90%',height: '100%' }" closeable>
        <div class="fabricContent">
          <div class="f-b title">
            <div>{{ $t('Index.ProductList.Price') }}（$）</div>
            <div>${{ priceSlider[0] * 200 / 100 }} - ${{ priceSlider[1] * 200 / 100 }}</div>
          </div>
          <div style="padding: 0 .3rem;margin-bottom: .6rem">
            <van-slider v-model="priceSlider" @change="resetPageForMobile" range active-color="#99C41C" />
          </div>
          <van-collapse v-model="activeNames" class="setTitleFont">
            <van-collapse-item :title="item.name" :name="item.code" v-for="item in productAttributeList" :key="item.code">
              <div class="f fw-w">
                <div class="multipleText" v-for="attr in item.value" :key="attr.code" @click="attributeChangeForMobile(attr)" :class="{multipleTextActived: attr.checked}">{{ attr.name }}</div>
              </div>
            </van-collapse-item>
          </van-collapse>
          <div class="bottomBtn f-b">
            <div style="width: 1rem">
              <div>{{ total }}</div>
              <div style="color: #7B7B7B">{{ $t('Index.ProductList.Products') }}</div>
            </div>
            <div @click="clearAllClick" class="clearAll">{{ $t('Index.ProductList.ClearAll') }}</div>
            <el-button type="primary" @click="submitForMobile">{{ $t('Index.ProductList.Submit') }}</el-button>
          </div>
        </div>
      </van-popup>
    </div>
  </section>
</template>

<script>
import API from '@/api'
// import bus from '@util/bus'
import _ from 'lodash'
import CategorySelect from './components/CategorySelect.vue'
import Filter from './components/Filter.vue'
import Sort from '@/views/commodity/components/Sort.vue'
import Product from '@/components/Product.vue'
import { largeHump } from '@/util/index'
import DropdownMenu from 'vant/lib/dropdown-menu'
import 'vant/lib/dropdown-menu/style'
import DropdownItem from 'vant/lib/dropdown-item'
import 'vant/lib/dropdown-item/style'
import cell from 'vant/lib/cell'
import 'vant/lib/cell/style'
import icon from 'vant/lib/icon'
import 'vant/lib/icon/style'
import popup from 'vant/lib/popup'
import 'vant/lib/popup/style'
import slider from 'vant/lib/slider'
import 'vant/lib/slider/style'
import Collapse from 'vant/lib/collapse'
import 'vant/lib/collapse/style'
import CollapseItem from 'vant/lib/collapse-item'
import 'vant/lib/collapse-item/style'
import getSortOptions from '@/config/sortOptions.js'
import SearchBar from '@/components/mobile/SearchBar.vue'
import bus from '@/util/bus'

export default {
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          name: 'keywords',
          content: this.meta.keywords
        },
        {
          name: 'description',
          content: this.meta.description
        }
      ]
    }
  },
  components: {
    'category-select': CategorySelect,
    'custom-filter': Filter,
    'product-sort': Sort,
    'product-item': Product,
    'custom-product': Product,
    'van-dropdown-menu': DropdownMenu,
    'van-dropdown-item': DropdownItem,
    'van-cell': cell,
    'van-icon': icon,
    'van-popup': popup,
    'van-slider': slider,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem,
    SearchBar
  },
  data() {
    return {
      meta: {
        title: 'wholesale',
        description: 'Price remain a remarkable 5% to 10% lower than the industry averag1e.',
        keywords: ''
      },
      isSearches: false, // 是否属于搜索模式
      listLoading: false,
      price: undefined,
      total: 0,
      listParams: {
        pageSize: 28,
        pageNumber: 1,
        categoryId: undefined,
        code: undefined, // 品类编码
        materialArray: [], // 材质
        minPrice: 0, // 区间最小售价
        maxPrice: 200, // 区间最大售价
        minStock: undefined, // 最小库存
        maxStock: undefined, // 最大库存
        sortName: undefined, // 需要排序的字段
        sortType: 'desc', // 排序方式：desc ,asc
        searchName: undefined, // 产品名称
        countryCodeArray: undefined, // 发货国家编码
        supplierLevels: [] // 供应商等级
      },
      productList: [],
      shippingFromList: [], // 发货地列表
      filterList: [],
      likeProductList: [],
      productAttributeList: [],
      mobileShipFrom: [],
      sortKeyForMobile: undefined,
      fabricShow: false,
      priceSlider: [0, 100],
      activeNames: ['season', 'shipFrom'],
      attributeOpenList: ['season', 'shipFrom', 'supplierRank'],
      categoryPageTitle: undefined, // 分类页面业务标题
      categoryPageDescription: undefined, // 分类页面业务描述
      isExpanded: false,
      selectCategoryList: []
    }
  },
  mounted() {
    // let keywords = this.$route.query.keywords
    // if (keywords) {
    // keywords.replace('%', '/')
    let keywords = this.$route.params.menu + (this.$route.params.param ? '/' + this.$route.params.param : '')
    API.getSeoBusinessId({ seoSearchTerm: keywords, type: 1 }).then(res => {
      let data = res.data || {}
      if (res.data && res.data.seoTitle) this.meta.title = data.seoTitle
      if (res.data && res.data.description) this.meta.title = data.seoDescription
      if (res.data && res.data.keywords) this.meta.title = data.seoKeyWords
      this.init(data.businessId || '')
    })
    //   return
    // }
    // this.init()
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollEvent)
  },
  computed: {
    isShowAdvertis() {
      return this.$store.state.isShowAdvertis
    },
    shippingFromListForMobile() {
      return this.shippingFromList.map(e => ({ text: e.countryCn, value: e.countryCode }))
    },
    sortListForMobile() {
      const arr = getSortOptions.call(this)
      arr.forEach(e => {
        e.text = e.name
        e.value = e.key
      })
      return arr
    },
    userId() {
      return this.$store.state.common.userId
    }
  },
  watch: {
    '$route.query.categoryId': function(value) {
      if (value !== undefined) {
        this.isSearches = false
        this.listParams.searchName = undefined
        this.listParams.categoryId = value
        this.$set(this.listParams, 'pageSize', 28)
        this.$nextTick(() => {
          const category = this.$refs.customCategory.setDefaultCategory(value)
          if (category) {
            this.filterList = []
            this.filterList.push({
              id: category.categoryId,
              name: category.name,
              type: 'category'
            })
            this.resetPage()
            this.$forceUpdate()
            this.getProductAttributeList()
          }
        })
      }
    },
    '$route.query.keywords': function(value) {
      if (value !== undefined) {
        this.isSearches = false
        this.listParams.searchName = undefined
        this.filterList = []
        API.getSeoBusinessId({ seoSearchTerm: value, type: 1 }).then(res => {
          let data = res.data || {}
          this.meta.title = data.seoTitle
          this.meta.description = data.seoDescription
          this.meta.keywords = data.seoKeyWords
          this.init(data.businessId || '')
        })
      }
    },
    '$route.query.search': function(value) {
      this.isSearches = !!value
      this.listParams.categoryId = undefined
      if (value !== undefined) this.listParams.searchName = value.includes(',') ? value.split(',') : [value]
      else this.listParams.searchName = undefined
      this.$set(this.listParams, 'pageSize', 30)
      this.resetPage()
    }
  },
  methods: {
    init(id) {
      const searches = this.$route.query.search
      if (searches) {
        this.isSearches = true
        this.listParams.searchName = searches.includes(',') ? searches.split(',') : [searches]
        this.$set(this.listParams, 'pageSize', 30)
      } else {
        let categoryId = id || this.$route.query.categoryId
        if (categoryId) {
          this.listParams.categoryId = categoryId
          this.$set(this.listParams, 'pageSize', 28)
          this.$nextTick(() => {
            let category = this.$refs.customCategory.setDefaultCategory(categoryId)
            // 过滤查询暂时不添加品类本身
            // if (category) {
            //   this.filterList.push({
            //     id: category.categoryId,
            //     name: category.name,
            //     type: 'category'
            //   })
            // }
          })
        }
      }
      this.getShippingFromList()
      this.getProductList()
      this.getProductAttributeList()
      if (!this.isPC) window.addEventListener('scroll', this.scrollEvent)
      bus.$on('mobileCategoryChange', category => {
        this.listParams.categoryId = category.categoryId
        this.resetPage()
      })
      this.$once('hook:beforeDestroy', () => {
        bus.$off('mobileCategoryChange')
      })
    },

    getProductList() {
      console.log('1213456')
      // this.total = 0
      this.listLoading = true
      const listParams = { ...this.listParams }
      if (listParams.countryCodeArray) listParams.countryCodeArray = [listParams.countryCodeArray]
      const attribute = this.generateAttributeParam()
      // let sizeIndex = attribute.findIndex(e => e.code === 'size')
      // // 抽取size参数
      // if (attribute.findIndex(e => e.code === 'size') !== -1) {
      //   const size = attribute.slice(sizeIndex, sizeIndex + 1)
      //   attribute.splice(sizeIndex, 1)
      //   listParams.sizeCodeArray = size[0].value
      // }
      if (attribute.length) listParams.attribute = JSON.stringify(attribute)
      API.getProductList(listParams).then(result => {
        this.productList = result.data.list
        this.total = result.data.total
        document.body.scrollTop = document.documentElement.scrollTop = 0
        if (this.productList.length === 0) {
          this.getIndexUserRecs()
        }
      }).finally(() => {
        this.listLoading = false
      })
      if (listParams && listParams.categoryId) {
        this.getCategoryTitleOrDescription(listParams.categoryId)
      }
    },
    // 获取分类页面业务描述
    getCategoryTitleOrDescription(businessId) {
      API.getSeoBusinessId({
        businessId: businessId,
        type: 1
      }).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        if (res.data) {
          this.categoryPageTitle = res.data.pageTitle
          this.categoryPageDescription = res.data.pageDescription
        }
      })
    },
    // 猜你喜欢
    getIndexUserRecs() {
      this.listLoading = true
      API.getIndexUserRecs({ pageNumber: 1, pageSize: 5 }).then(({ data }) => {
        this.likeProductList = data.list || []
      })
    },
    generateAttributeParam() {
      const result = []
      this.productAttributeList.forEach(item => {
        const value = item.value.filter(attr => attr.checked).map(attr => attr.code)
        if (value.length) {
          result.push({
            code: item.code,
            value
          })
        }
      })
      return result
    },
    getShippingFromList() {
      API.getShippingFromList({
        pageSize: 100,
        pageNumber: 1
      }).then(result => {
        // 以国家编码去重 且中国南中国北合并
        const map = {}
        result.data.list.forEach(item => {
          if (['CN_N', 'CN_S'].includes(item.countryCode)) {
            map['CN'] = {
              countryCn: 'China',
              countryCode: 'CN'
            }
            return
          }
          map[item.countryCode] = {
            countryCn: item.countryCn,
            countryCode: item.countryCode
          }
        })
        this.shippingFromList = Object.values(map)
      })
    },
    getProductAttributeList() {
      const listParams = { ...this.listParams }
      if (listParams.countryCodeArray) listParams.countryCodeArray = [listParams.countryCodeArray]
      API.getProductAttributeList(listParams).then(({ data }) => {
        data.forEach(item => {
          try {
            item.value = JSON.parse(item.value)
            item.name = largeHump(item.code.replace('_', ' '))
            item.value = item.value.map(e => {
              return {
                name: e,
                code: e,
                checked: false
              }
            })
          } catch (error) {
            item.value = []
          }
        })
        this.productAttributeList = data
        this.getSizeList()
      })
    },
    closeTag(tag, index) {
      this.filterList.splice(index, 1)
      switch (tag.type) {
        case 'category':
          this.listParams.categoryId = undefined
          this.$refs.customCategory.reset()
          break
        case 'attribute':
          this.productAttributeList.forEach(item => {
            item.value.forEach(attr => {
              if (attr.code === tag.code) {
                this.$set(attr, 'checked', false)
              }
            })
          })
      }

      this.resetPage()
    },
    closeAllTag() {
      this.filterList = []
      this.productAttributeList.forEach(item => {
        item.value.forEach(attr => {
          this.$set(attr, 'checked', false)
        })
      })
      this.resetPage()
    },
    resetPage() {
      // this.isPC && this.$refs.scroll.scrollTo({ y: 0 }, 0)
      this.listParams.pageNumber = 1
      this.getProductList()
    },
    pageChange(page) {
      // if (!this.userId) {
      //   this.$router.push('/login')
      //   return
      // }
      this.$set(this.listParams, 'pageNumber', page)
      this.getProductList()
    },
    priceChange([minPrice, maxPrice]) {
      this.listParams.minPrice = minPrice
      this.listParams.maxPrice = maxPrice
      this.resetPage()
    },
    sortChange(sortName, sortType) {
      this.listParams.sortName = sortName
      this.listParams.sortType = sortType
      this.resetPage()
    },
    categoryChange(categoryId, category) {
      this.listParams.categoryId = categoryId
      // 清空尺寸
      let size = this.productAttributeList.find(e => e.name === 'Size')
      size.value.forEach(e => this.$set(e, 'checked', false))
      this.resetPage()
      this.getSizeList()
      if (!categoryId) {
        const index = this.filterList.findIndex(item => item.type === 'category')
        index > -1 && this.filterList.splice(index, 1)
        return
      }
      const index = this.filterList.findIndex(item => item.id === categoryId)
      // // 过滤查询暂时不添加品类本身
      // if (find) {
      //   this.filterList.splice(index, 1, {
      //     id: categoryId,
      //     name: category.name,
      //     type: 'category'
      //   })
      // } else {
      //   this.filterList.push({
      //     id: categoryId,
      //     name: category.name,
      //     type: 'category'
      //   })
      // }
      this.getProductAttributeList()
    },
    attributeChange({ code, name, checked }) {
      if (checked) {
        this.filterList.push({
          code,
          name,
          type: 'attribute'
        })
      } else {
        const index = this.filterList.findIndex(item => item.code === code)
        this.filterList.splice(index, 1)
      }
      this.resetPage()
    },
    getSizeList() {
      // 尺寸从品类来
      if (this.listParams.categoryId) {
        API.getSizeList({ categoryId: this.listParams.categoryId }).then(res => {
          const sizeList = res.data.map(e => ({ code: e, name: e, checked: false }))
          let sizeIndex = this.productAttributeList.findIndex(e => e.code === 'size')
          if (sizeIndex !== -1) this.productAttributeList.splice(sizeIndex, 1)
          this.productAttributeList = [...this.productAttributeList, { code: 'size', name: 'Size', value: sizeList }]
          /*
        展示顺序
        Style、 Season、 Pattern、 Material、 Size、 Sleeve Length、 Waistline、 Sleeve Type
      */
          const orderArr = ['style', 'season', 'pattern', 'material', 'size', 'sleeve_length', 'waistline', 'sleeve_type']
          this.productAttributeList.forEach((e, i) => {
            let index = orderArr.findIndex(ee => ee === e.code)
            e.orderNum = index
          })
          this.productAttributeList.sort((a, b) => b.orderNum - a.orderNum).reverse()
        })
      } else {
        // 未选品类则默认女装尺寸
        const size = {
          code: 'size',
          name: 'Size',
          value: [
            { code: 'XS', name: 'XS' },
            { code: 'S', name: 'S' },
            { code: 'M', name: 'M' },
            { code: 'L', name: 'L' },
            { code: 'XL', name: 'XL' },
            { code: 'XXL', name: 'XXL' }
          ]
        }
        let sizeIndex = this.productAttributeList.findIndex(e => e.code === 'size')
        if (sizeIndex !== -1) this.productAttributeList.splice(sizeIndex, 1)
        this.productAttributeList = [...this.productAttributeList, size]
        /*
        展示顺序
        Style、 Season、 Pattern、 Material、 Size、 Sleeve Length、 Waistline、 Sleeve Type
      */
        const orderArr = ['style', 'season', 'pattern', 'material', 'size', 'sleeve_length', 'waistline', 'sleeve_type']
        this.productAttributeList.forEach((e, i) => {
          let index = orderArr.findIndex(ee => ee === e.code)
          e.orderNum = index
        })
        this.productAttributeList.sort((a, b) => b.orderNum - a.orderNum).reverse()
      }
    },
    shipFromChangeMobile(value) {
      this.$set(value, 'checked', !value.checked)
      this.resetPageForMobile()
    },
    sortChangeMobile(value) {
      const { sortName, sortType } = this.sortListForMobile.find(e => e.value === value)
      this.sortChange(sortName, sortType)
    },
    attributeChangeForMobile(attr) {
      this.$set(attr, 'checked', !attr.checked)
      const { code, name, checked } = attr
      if (checked) {
        this.filterList.push({
          code,
          name,
          type: 'attribute'
        })
      } else {
        const index = this.filterList.findIndex(item => item.code === code)
        this.filterList.splice(index, 1)
      }
    },

    // 搜索
    searchHandle(searchText) {
      const router = {
        path: '/product-list'
      }
      if (searchText) router.query = { search: searchText }
      this.$router.push(router)
      this.listParams.categoryId = undefined
      this.resetPageForMobile()
    },
    resetPageForMobile() {
      this.listParams.pageNumber = 1
      this.productList = []
      this.getProductListForMobile()
    },
    submitForMobile() {
      this.resetPageForMobile()
      this.fabricShow = false
    },
    scrollEvent() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      if (scrollTop + windowHeight >= scrollHeight) {
        if (this.total > this.productList.length && !this.listLoading) {
          this.listParams.pageNumber++
          this.getProductListForMobile()
        }
      }
    },
    getProductListForMobile() {
      // this.total = 0
      this.listLoading = true
      const listParams = { ...this.listParams, ...this.getPriceForMobile(), countryCodeArray: this.getCountryCodeArray() }
      const attribute = this.generateAttributeParam()
      // let sizeIndex = attribute.findIndex(e => e.code === 'size')
      // // 抽取size参数
      // if (attribute.findIndex(e => e.code === 'size') !== -1) {
      //   const size = attribute.slice(sizeIndex, sizeIndex + 1)
      //   attribute.splice(sizeIndex, 1)
      //   listParams.sizeCodeArray = size[0].value
      // }
      if (attribute.length) listParams.attribute = JSON.stringify(attribute)
      API.getProductList(listParams).then(result => {
        this.productList = [...this.productList, ...result.data.list]
        this.total = result.data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    getPriceForMobile() {
      let base = 200 / 100
      const price = {
        minPrice: this.priceSlider[0] * base,
        maxPrice: this.priceSlider[1] * base
      }
      return price
    },
    getCountryCodeArray() {
      let countryCodeArray = this.shippingFromList.filter(e => e.checked).map(e => e.countryCode)
      return countryCodeArray.length ? countryCodeArray : undefined
    },
    clearAllClick() {
      this.productAttributeList.forEach(e => {
        e.value.forEach(v => {
          v.checked = false
        })
      })
      this.priceSlider = [0, 100]
      this.resetPageForMobile()
    },
    closeTagForWarehouse() { },
    closeAllTagForWarehouse() { },
    warehouseTagClick(item) {
      this.$set(item, 'active', !item.active)
      this.listParams.countryCodeArray = this.shippingFromList.filter(e => e.active).map(e => e.countryCode)
      this.resetPage()
    },

    selectCategory(selectCategoryList) {
      this.selectCategoryList = selectCategoryList
    },

    jumpCategory(item, index) {
      // console.log(index, this.selectCategoryList)
      this.$refs.customCategory.back(index + 1)
    },
    toggleDescription() {
    // 在这里编写展开文字描述的逻辑
    // 可以使用一个 data 变量来控制文字描述的展开与收起
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list {
  max-width: 1430px;
  padding: 0 15px;
  margin: 0 auto;
  .navigation {
    max-width: 1400px;
    width: 100vw;
    height: 48px;
    line-height: 50px;
    position: fixed;
    white-space: nowrap;
    z-index: 100;
    padding-left: 4px;
    background-color: #f5f7f7;
}
  .filter {
    width: 250px;
    position: fixed;
    bottom: 10px;
    left: calc((100vw - 1400px) / 2);
    background: #ffffff;

    .filter-title {
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #1f2937;
      padding: 20px 0 5px 0;
    }
  }

  .product-box {
    padding: 0 0 0 280px;
    .product-box-header {
      padding: 50px 0 10px 0;
    }
    .product-box-list {
      margin-top: 5px;
      .empty-product {
        width: 252px;
        height: 0;
      }
      .product_item {
        /deep/.product-single {
          margin: 0;
        }
      }
      /deep/ .title-price {
        padding-top: 8px;
      }
    }
    .empty {
      padding: 50px 0 0 0;
      p {
        padding: 20px 0;
      }
    }
    .warehouse_box {
      .warehouse_tag {
        margin-right: 4px;
        border: 1px solid #cdd4dd;
        padding: 6px 8px;
        border-radius: 6px;
      }
      .active {
        border: 1px solid #99c41c;
        color: #99c41c;
      }
    }
  }
}
@media screen and (min-width: 1000px) and(max-width: 1400px ) {
  .filter {
    left: 15px !important;
  }
}

// 商品属性下拉面板css修改
/deep/.el-collapse-item__header,
.el-collapse {
  border: none;
}
/deep/.el-collapse-item__header {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #1f2937;
  padding: 20px 0 5px 0;
}
/deep/.el-collapse-item__content {
  padding: 15px 0;
}

.mobileContain {
  // min-height: 100vh;
  .topForm {
    display: flex;
    position: fixed;
    top: 0.86rem;
    left: 0;
    right: 0;
    z-index: 10;
    /deep/.van-dropdown-menu {
      flex: 2;
    }
    /deep/.van-dropdown-menu__bar {
      box-shadow: none;
    }
    .Fabric {
      flex: 1;
      line-height: 48px;
      background-color: #fff;
      z-index: 2;
      text-align: center;
      position: relative;
    }
  }
  .fabricContent {
    padding: 60px 0 20px;
    position: relative;
    min-height: 100vh;
    .title {
      font-weight: bold;
      font-size: 0.3rem;
      margin-bottom: 0.6rem;
      padding: 0 0.3rem;
    }
    .multipleText {
      padding: 0.1rem 0.2rem;
      border: 1px solid #cdd4dd;
      margin: 0 0.2rem 0.2rem 0;
    }
    .multipleTextActived {
      color: #99c41c;
      border-color: #99c41c;
    }
    .bottomBtn {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 1rem;
      border-top: 1px solid #f1f1f1;
      width: 100%;
      padding: 0.1rem 0.3rem;
      align-items: center;
      .clearAll {
        color: #7b7b7b;
      }
    }
    .setTitleFont {
      margin-bottom: 1rem;
      /deep/.van-cell__title {
        font-weight: bold;
      }
    }
  }
  .productList {
    padding: 0.2rem;
    margin-top: 1rem;
    /deep/.product-single {
      margin: 0;
    }

    .empty {
      padding: 20px;
      img {
        width: 60%;
      }
      p {
        margin-top: 20px;
      }
    }
  }
  .warehouse_box {
    .warehouse_tag {
      margin-right: 0.2rem;
      border: 1px solid #cdd4dd;
      padding: 0.1rem 0.2rem;
      border-radius: 0.2rem;
    }
    .active {
      border: 1px solid #99c41c;
      color: #99c41c;
    }
  }
}
.top-search {
  padding: 0.2rem 0.3rem;
  background: #fff;
}
.shipFromRadio {
  /deep/label {
    width: 100%;
    margin-bottom: 10px;
  }
}

.description {
  margin-top: 10px; /* 增加文字段落和按钮的上边距 */
  display: flex;
  position: relative;
  flex-direction: column; /* 将按钮和文本放在垂直方向 */
}

.description-text {
  word-wrap:break-word;
  margin-top: 10px; /* 增加文字段落和按钮的上边距 */
  margin-bottom: 20px; /* 增加文字段落和按钮的下边距 */
  overflow: hidden;
  padding:  0 20px;
  box-sizing: border-box;
}

.description > div.collapsed {
  max-height: 500px; /* 控制默认最大高度，可根据需求修改 */
  overflow: hidden;
}
.toggle-button {
  align-self: flex-end;
  color: #99c41c;
  padding: 4px 8px;
  cursor: pointer;
  z-index: 1;
  position: absolute;
  font-size: 21px;
}

.toggle-title {
  color: #0d0e0d;
  padding: 4px 20px;
  cursor: pointer;
  z-index: 1;
}

.custom-divider {
  margin-top: 50px;
}
</style>
